var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "twoLevelList" }, [
    this.$store.state.webNavigator == "pc"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "twoTlt-list" },
            _vm._l(_vm.navList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "font20px twoTlt-list-li displayIB",
                  class: _vm.active == index ? "li-active" : "",
                  on: {
                    click: function($event) {
                      return _vm.Cactive(index, item)
                    }
                  }
                },
                [_vm._v(_vm._s(item.text) + "\n      ")]
              )
            }),
            0
          )
        ])
      : _vm._e(),
    this.$store.state.webNavigator == "phone"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "phone-TowListBox" },
            _vm._l(_vm.navList, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "phone-TowListBtn",
                  class: _vm.active == index ? "li-active" : "",
                  on: {
                    click: function($event) {
                      return _vm.Cactive(index, item)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]
              )
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9ee13e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9ee13e2","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/twoLevelList/twoLevelList.vue
// module id = 798
// module chunks = 3 4 5 6 7 8 9 10 11